import * as React from 'react';
import { connect } from 'react-redux';

class Loading extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[Loading.jsx] ";
    }

    render() {
        console.log(this.componentName + 'render');
        return (
            this.props.toogleLoading === 'show' ?
                <div className="loading">
                    <div className="loading-bar"></div>
                    <div className="loading-bar"></div>
                    <div className="loading-bar"></div>
                    <div className="loading-bar"></div>
                </div>
                : null
        );
    }
}


function mapStateToProps(state) {
    return {
        "toogleLoading": state.app.toogleLoading,
    }
};

export default connect(mapStateToProps, null)(Loading);







